import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Sofía Ramírez',
    city: 'Córdoba',
    text: 'Como recién graduada, me daba terror atender TCA. Este kit me dio un mapa exacto de qué preguntar y cómo armar el plan. ¡Fundamental para ganar seguridad en el consultorio!'
  }, {
    name: 'Martina Gómez',
    city: 'Rosario',
    text: 'Hace años atiendo clínica general, pero derivaba los TCA por falta de estructura. Ahora me siento segura para abordarlos. Las guías paso a paso son súper prácticas y aplicables.'
  }, {
    name: 'Leandro Fernández',
    city: 'Buenos Aires',
    text: 'El registro cognitivo-conductual adaptado a TCA vale oro. Mis pacientes lo entienden perfecto y me facilita muchísimo el trabajo en sesión. Un material de altísima calidad.'
  }, {
    name: 'Carolina Sosa',
    city: 'Mendoza',
    text: 'Lo que más destaco es la guía para familiares. Siempre era un punto ciego en mis tratamientos y ahora sé exactamente cómo orientarlos sin perder el foco en la paciente.'
  }, {
    name: 'Julieta Acosta',
    city: 'La Plata',
    text: 'No es pura teoría, es 100% aplicable. Desde la primera consulta hasta el alta, tenés todo ordenado. Excelente inversión para la práctica clínica, te ahorra muchísimas horas de planificación.'
  }];
  return <section className="py-16 px-4 bg-brand-cream-dark" data-id="element-148">
      <div className="max-w-6xl mx-auto" data-id="element-149">
        <h3 className="text-center font-serif text-2xl font-bold text-brand-teal-dark mb-10" data-id="element-150">
          Lo que dicen otros profesionales
        </h3>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-151">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-152">
              <div className="flex gap-1 mb-4" data-id="element-153">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-154" />)}
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-6 italic" data-id="element-155">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-156">
                <div className="w-10 h-10 rounded-full bg-brand-teal/10 flex items-center justify-center text-brand-teal font-bold uppercase" data-id="element-157">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-158">
                  <p className="font-bold text-brand-teal-dark text-sm" data-id="element-159">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-160">{t.city}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};